export const IMAGE_UPLOAD = 'IMAGE_UPLOAD';
export const SET_UP_CANVAS_SIZE = 'SET_UP_CANVAS_SIZE';
export const MAKE_VERTEX = 'MAKE_VERTEX';
export const MAKE_FACE = 'MAKE_FACE';
export const EDIT_MODE_TOGGLE = 'EDIT_MODE_TOGGLE';
export const AUTO_POPULATE = 'AUTO_POPULATE';
export const SET_BACKGROUND_POLY = 'SET_BACKGROUND_POLY';
export const DOWNLOAD_FLATTEN_IMG = 'DOWNLOAD_FLATTEN_IMG';
export const SELECT_LAYER = 'SELECT_LAYER';
export const SELECT_FACE = 'SELECT_FACE';
export const ADJUST_VERTEX_POSITION = 'ADJUST_VERTEX_POSITION';
export const NOTICE_MESSAGE = 'NOTICE_MESSAGE';
export const SELECTED_POLY_COLOR_CHANGE = 'SELECTED_POLY_COLOR_CHANGE';
export const DELETE_POLY = 'DELETE_POLY';